// @license Copyright (c) 2016 Copyright Holder All Rights Reserved.
(function() {
    "use strict";

    angular.module("swurveys.common").directive("ngMobileClick", Handler)

    function Handler($parse) {
        return function(scope, element, attr) {
            var clickHandler = $parse(attr.ngMobileClick);

            var documentClick = false;

            element.on('touchstart', function() {
                documentClick = true;
            });
            element.on('touchmove', function() {
                documentClick = false;
            });
            element.on('click touchend', function(event) {
                if (event.type == "click")
                    documentClick = true;
                if (documentClick) {
                    scope.$apply(function() {
                        clickHandler(scope, {$event: event});
                    });
                }
            });
        };
    }
}());
